import api from './api';

class InventoryService {
  getAvailableInventories = async () => {
    try {
      const response = await api.get('/inventories/active');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };

  handleError = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return new Error(data.message || 'Bad request');
        case 401:
          return new Error('Unauthorized access');
        case 404:
          return new Error('No inventories available');
        default:
          return new Error(data.message || 'Failed to fetch inventories');
      }
    } else if (error.request) {
      return new Error('No response from server. Please check your connection.');
    } else {
      return new Error('Request error: ' + error.message);
    }
  };
}

export default new InventoryService();